




















import { Component, Prop, Vue } from 'vue-property-decorator';
import ContentLoader from './content-loader.vue';

@Component({
  components: {
    ContentLoader,
  },
})
export default class BaseComponent extends Vue {
  /** 组件是否初始化完成 */
  @Prop({ default: false }) isReady!: boolean;
}
